import { Component, Input } from '@angular/core';
import { NexusFormResultModel } from 'app/core/models/nexus-form-result.model';

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'nexus-form-result',
    templateUrl: './nexus-form-result.component.html',
    styleUrls: ['./nexus-form-result.component.scss'],
    standalone: false
})
export class NexusFormResultComponent {
  @Input() public model: NexusFormResultModel;

  constructor() { }

}
